export const views = {
    closed: 'closed',
    fly: 'fly',
    chat: 'chat',
};

export const viewProptypeOneOf = Object.values(views);
